import http from './api'

const route = 'app/comercial/analiseprodutos3/'

export default {
  showAnaliseFat: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, classificacao, produto) => {
    return http.post(route + 'showAnaliseFat', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      classificacao: classificacao,
      produto: produto,
    })
  },

  showAnaliseProdDevolucao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, classificacao, produto) => {
    return http.post(route + 'showAnaliseProdDevolucao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      classificacao: classificacao,
      produto: produto,
    })
  },

  showAnaliseQuantidadeFaturados: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, classificacao, produto) => {
    return http.post(route + 'showAnaliseQuantidadeFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      classificacao: classificacao,
      produto: produto,
    })
  },

  showAnaliseProdutoFaturamentoClassificacao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, classificacao, produto) => {
    return http.post(route + 'showAnaliseProdutoFaturamentoClassificacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      classificacao: classificacao,
      produto: produto,
    })
  },

  showGraficoFatPrecoMedioGrupoClassificacao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, classificacao, produto) => {
    return http.post(route + 'showGraficoFatPrecoMedioGrupoClassificacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      classificacao: classificacao,
      produto: produto,
    })
  },

  showQuantidadeTotal: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, classificacao, produto) => {
    return http.post(route + 'showQuantidadeTotal', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      classificacao: classificacao,
      produto: produto,
    })
  },

  showAnaliseProdutoDevolucaoClassificacao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, classificacao, produto) => {
    return http.post(route + 'showAnaliseProdutoDevolucaoClassificacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      classificacao: classificacao,
      produto: produto,
    })
  },

  showAnaliseFaturamentoGrupoProdutos: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, classificacao, produto) => {
    return http.post(route + 'showAnaliseFaturamentoGrupoProdutos', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      classificacao: classificacao,
      produto: produto,
    })
  },

  showAnaliseCompartivoFaturamentoMes: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, classificacao, produto) => {
    return http.post(route + 'showAnaliseCompartivoFaturamentoMes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      classificacao: classificacao,
      produto: produto,
    })
  },

  showFaturamentoGrupoMesClassificacao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, classificacao, produto) => {
    return http.post(route + 'showFaturamentoGrupoMesClassificacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      classificacao: classificacao,
      produto: produto,
    })
  },
}
